const user = resolve => require(['@/components/user/back'],resolve);
export default [
	{
		path : 'user/back',
		name : 'user',
		component : user,
		meta : {
			title : '客户返程',
			notNeedGlobalScroll : true,
			searchDisabled : true
		}
	}
]


// WEBPACK FOOTER //
// ./src/router/user/index.js